module.exports = __webpack_public_path__ + "static/media/Montana2921.bd4f8e01.jpg";